<!--
 * @Author       : NN
 * @Date         : 2020-08-05
 * @Description  : 发行优惠券
 -->
<template>
	<div class="goods-add" :style="goodsstyle">
		<a-card :bordered="false">
			<a-card title="发行优惠券" :bordered="false">
				<a-form class="boxs" :form="form">
					<a-form-item label="优惠券类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-select @change="changeType" placeholder="请选择优惠券类型" v-decorator="['activity_type', { rules: [{ required: true,message: '请选择优惠券类型'}] }]" style="width: 300px;">
						  <a-select-option v-for="(item,index) of coupon_list" :key="index" :value="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-item>
					<a-form-item label="优惠券名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input placeholder="请输入优惠券名称" v-decorator="['name', { rules: [{ required: true,message: '请输入优惠券名称'}] }]" style="width: 300px;"></a-input>
					</a-form-item>
					<a-form-item label="发行数量" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input type="number" min="1" placeholder="请输入发行数量" v-decorator="['circulation', { rules: [{ required: true,message: '请输入发行数量'}] }]" style="width: 300px;"></a-input>
						张
					</a-form-item>
					<a-form-item v-if="activity_type==2" label="面值" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input type="number" min="1" placeholder="请输入优惠券面值" v-decorator="['money', { rules: [{ required: true,message: '请输入优惠券面值'}] }]" style="width: 300px;"></a-input>
						元
					</a-form-item>
					<a-form-item v-if="activity_type==3" label="折扣值" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-input type="number" min="1" placeholder="请输入折扣值" v-decorator="['discount', { rules: [{ required: true,message: '请输入折扣值'}] }]" style="width: 300px;"></a-input>
						折
					</a-form-item>
					<a-form-item label="消费门槛" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						消费
						<a-input type="number" min="0" v-decorator="['z_money', { rules: [{ required: true,message: '请输入消费门槛'}] }]" style="width: 180px;margin-left: 10px"></a-input>
						元可使用
						<span style="color: #969DA8">（为0，则不限制）</span>
					</a-form-item>
					<a-form-item label="可用范围" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-radio-group @change="rangeChange" v-decorator="['type',{ initialValue:type }]">
						    <a-radio :value="1">
								全部商品
						    </a-radio>
						    <a-radio :value="2">
						      指定商品
						    </a-radio>
							<a-radio :value="3">
							  指定分类
							</a-radio>
						  </a-radio-group>
						  
						  <div class="rangeBox" v-if="type!=1">
							  <div>
									<a-select 
										v-if="type == 2"
										mode="multiple"
										size="default"
										:showArrow="true"
										:placeholder="placeholderFlag?'请选择指定商品':''"
										v-decorator="['menu_list',{ initialValue:selectRange }]"
										:filter-option="false"
										style="width: 440px;"
										@change="handleChange"
										@popupScroll="popupScroll"
										@search="searchIpt"
										@focus="focusSearch"
										@blur="blurSearch"
									>
										<a-select-option v-for="(item,index) in select_list" :key="item.id">
											{{item.name}}
										</a-select-option>
									</a-select>
									
									<a-select
										v-if="type == 3"
										mode="multiple"
										size="default"
										:showArrow="true"
										:filter-option="filterOption"
										:placeholder="placeholderFlag?'请选择指定分类':''"
										v-decorator="['menu_list',{ initialValue:selectRange }]"
										style="width: 440px;"
										@change="handleChange"
										@search="searchIpt1"
										@blur="blurSearch"
									>
										<a-select-option v-for="(item,index) in select_list" :key="item.id">
											{{item.name}}
										</a-select-option>
									</a-select>
									
									<a-button @click="addRange" style="margin-left: 8px;">添加</a-button>
							  </div>
							  
							  <div class="rangeCheckBox">
								  <span>已选：</span>
								  <div class="rangeCheckBox_data">
										<a-tag v-for="item,index of selectRangeItem" :key="index" closable @close="delSelect(item)">{{item.name}}</a-tag>
								  </div>
							  </div>
						  </div>
					</a-form-item>
					<!-- <a-form-item label="优惠券跳转配置" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-radio-group @change="jumpChange" v-decorator="['jump', { initialValue:checkJump }]">
						    <a-radio :value="1">
								店铺首页
						    </a-radio>
						    <a-radio :value="2">
						      自定义
						    </a-radio>
						</a-radio-group>
						  
						<a-form-item v-if="checkJump==2" label="跳转地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" style="display: flex;align-items: center;width: 724px;height: 64px; background:rgba(246,247,248,1); border-radius:2px; padding: 0 14px; box-sizing: border-box;">
							<div class="jumpBox" >
								<div>
									<a-input v-decorator="['jumpUrl', { rules: [{ required: true,message: '请输入自定义跳转地址'}] }]"></a-input>
								</div>
								<span>（点击去使用，可配置跳转打开的地址）</span>
							</div>
						</a-form-item>
						  
					</a-form-item> -->
					<a-form-item label="有效时间" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-range-picker
						      :show-time="{
						        hideDisabledOptions: true,
						        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
						      }"
						      format="YYYY-MM-DD HH:mm:ss"
							  v-decorator="['rangeDate',{ rules: [{ required: true,message: '请选择有效时间'}] }]"
							  :placeholder="['请选择开始时间', '请选择结束时间']"
						    />
					</a-form-item>
					<a-form-item label="领取限制" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						每人限领
						<a-input v-if="limit_type==1" type="number" min="1" v-decorator="['receive', { rules: [{ required: true,message: '请输入领取限制'}] }]" style="width: 180px;margin-left: 10px"></a-input>
						<a-input v-else disabled type="number" v-decorator="['receive', { rules: [{ required: true,message: '请输入领取限制'}] ,initialValue:1}]" style="width: 180px;margin-left: 10px"></a-input>
						张
					</a-form-item>
					<a-form-item label="使用说明" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
						<a-textarea v-decorator="['Instructions']" placeholder="请输入使用说明" auto-size style="width: 454px;height: 70px;"/>
					</a-form-item>
				</a-form>
			</a-card>
			
			<div style="height: 40px;"></div>

			<div class="foot">
				<a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
				<a-button type="primary" @click="onSave">保存</a-button>
			</div>
		</a-card>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	data() {
		return {
			moment,
			form: this.$form.createForm(this, { name: 'form_in_modal' }),
			goodsstyle: {},
			coupon_list: [],
			type: 1,
			checkJump: 1,
			
			searchName: '',
			
			selectRange: [], //选中的指定范围的value集合
			select_list: [],  //可用范围的所有选项
			selectRangeItem: [],  //选中的指定范围的对象集合
			
			limit_type: '',  //0:单张 1:多张
			
			page: 1,
			
			activity_type: '', //优惠券类型
			placeholderFlag: true
		};
	},
	mounted() {
		let content = document.querySelectorAll('.ant-layout-content')[0].offsetHeight;
		this.goodsstyle = {
			height: content + 'px'
		};
		
		this.axios()
	},
	methods: {
		changeType(e){
			this.activity_type = e
		},
		filterOption(inputValue, option){
			return (
			  option.componentOptions.children[0].text.includes(inputValue)
			);
		},
		axios(){
			let url = '?module=pc_api&action=coupon&app=add_page';
			
			this.$request.post(url).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.limit_type = data.limit_type
					this.coupon_list = data.coupon_type_list
				}else{
					this.$message.error(message)
				}
			});
		},
		addRange(){
			let selectRangeItem = []
			this.select_list.filter(items=>{
				this.selectRange.filter(item=>{
					if(item == items.id){
						selectRangeItem.push(items)
					}
				})
			})
			
			// 筛选出已选中的目前下拉框没有的子项ID
			let filterId = []
			this.selectRange.filter(items=>{
				let index = selectRangeItem.findIndex(item=>{
					return items == item.id
				})
				
				if(index<0){
					filterId.push(items)
				}
			})
			
			// 筛选出已选中的目前下拉框没有的子项
			let filterItem = []
			this.selectRangeItem.filter(items=>{
				filterId.filter(item=>{
					if(items.id == item){
						filterItem.push(items)
					}
				})
			})
			
			// 目前下拉框选中的子项及目前下拉框中没有的子项之和即为已选中的项
			this.selectRangeItem = [...filterItem,...selectRangeItem]
		},
		delSelect(item){
			let selectRangeItem = JSON.parse(JSON.stringify(this.selectRangeItem))
			
			let i = this.selectRange.findIndex(items=>{
				return items == item.id
			})
			this.selectRange.splice(i,1)
			selectRangeItem.splice(i,1)
			
			this.selectRangeItem = []
			setTimeout(()=>{
				this.selectRangeItem = selectRangeItem
			},1)
		},
		handleChange(e){
			this.selectRange = e
		},
		popupScroll(e){
			let dom = e.currentTarget
			if (dom.scrollHeight  - dom.scrollTop <= dom.clientHeight) {
				this.page++
				this.get_pro()
			}
		},
		/* 
			选择跳转配置
		 */
		jumpChange(e){
			this.checkJump = e.target.value
		},
		/* 
			选择可用范围
		 */
		rangeChange(e){
			this.type = e.target.value
			
			this.page = 1
			this.selectRange = []
			this.select_list = []
			this.selectRangeItem = []
			this.placeholderFlag = true
			
			this.form.setFieldsValue({"menu_list":undefined})
			
			if(this.type == 2){
				this.get_pro()
			}else if(this.type == 3){
				this.get_class()
			}
		},
		get_class(){
			let url = '?module=pc_api&action=coupon&app=fenlei';
			this.$request.post(url).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.select_list = data
				}else{
					this.$message.error(message)
				}
			});
		},
		get_pro(){
			let data = {
				name:this.searchName, // 商品名称
				page:this.page, // 页码
			}
			let url = '?module=pc_api&action=coupon&app=product';
			this.$request.post(url,data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					if(this.page == 1){
						this.select_list = data
					}else{
						this.select_list.push(...data)
					}
				}else{
					this.$message.error(message)
				}
			});
		},
		focusSearch(){
			this.searchName = ''
			this.page = 1
			this.get_pro()
		},
		searchIpt1(e){
			if(e == ''){
				this.placeholderFlag = true
			}else{
				this.placeholderFlag = false
			}
		},
		blurSearch(){
			this.placeholderFlag = true
		},
		searchIpt(e){
			this.searchName = e
			
			if(e == ''){
				this.placeholderFlag = true
			}else{
				this.placeholderFlag = false
			}
			
			this.page = 1
			this.get_pro()
		},
		/* 
			保存
		 */
		onSave(){
			this.form.validateFields((err, values) => {
			  if (!err) {
			    let start_time,end_time
			    let { rangeDate, type } = values
			
			    if (rangeDate) {
			      // 开始时间
			      start_time = rangeDate[0].format("YYYY-MM-DD HH:mm:ss");
			      // 结束时间
			      end_time = rangeDate[1].format("YYYY-MM-DD HH:mm:ss");
			    }
				
				let data = {
					start_time,end_time,
					...values
				}
				
				let list = []
				if(this.selectRangeItem.length>0){
					this.selectRangeItem.filter(item=>{
						if(type == 2){
							list.push(item.name)
						}else if(type == 3){
							list.push(item.id)
						}
					})
				}
				if(type == 2){
					data.menu_list = list.join()
				}else if(type == 3){
					data.menu_list = ''
					data.class_list = list.join()
				}
				
				let url = '?module=pc_api&action=coupon&app=add';
				this.$request.post(url,data).then(res => {
					let { code, message, data } = res;
					if(code == 200){
						this.$message.success(message)
						
						setTimeout(()=>{
							this.$router.go(-1)
						},1000)
					}else{
						this.$message.error(message)
					}
				});
			  }
			})
		},
		/**
		* @name 返回
		* */ 
		onGoBack(){
		  this.$router.go(-1)
		},
	}
};
</script>

<style lang="less" scoped>
.modals {
	/deep/ .ant-form-item {
		margin-bottom: 0px;
	}

	.boxs {
		display: flex;
		height: 36px;
		min-height: 36px;
		padding-top: 0px;
		align-items: center;
		width: 410px;
		justify-content: space-between;
	}
}
.goods-add {
	height: 100%;
	overflow-y: auto;
	.foot {
		height: 68px;
		width: 100%;
		border-top: 1px solid #e9ecef;
		position: sticky;
		bottom: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0px 60px;
		background: #ffffff;
		z-index: 999;

		.btns {
			margin-right: 10px;
		}
	}

	/deep/ .ant-card-head {
		position: sticky !important;
		top: 0 !important;
		background: #ffff !important;
		z-index: 991 !important;
	}
}

.boxs {
	padding-top: 40px;
	min-height: 400px;
}

.clearfix {
	position: relative;
	width: 600px;
}
.setMap0,
.setMap1,
.setMap2,
.setMap3,
.setMap4 {
	position: absolute;
	bottom: 8px;
	height: 20px;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	width: 104px;
	background: rgba(0, 0, 0, 0.6);
	color: #ffffff;
	z-index: 99;
	cursor: pointer;
}
.setMap0 {
	left: 0;
	background: #2890ff;
	width: 32px;
}
.setMap1 {
	left: 112px;
}
.setMap2 {
	left: 224px;
}
.setMap3 {
	left: 336px;
}
.setMap4 {
	left: 448px;
}

/deep/ .ant-card-body{
	padding: 0;
}
/deep/ .ant-form-item{
	margin-bottom: 14px;
}

.jumpBox{
	display: flex;
	align-items: center;
	
	>div{
		flex: 1;
	}
}

.rangeBox{
	width:724px;
	padding: 14px;
	background:rgba(246,247,248,1);
	border-radius:2px;
	
	/deep/ .ant-select-selection__rendered>ul .ant-select-selection__choice{
		display: none;
	}
	/deep/ .ant-select-selection__placeholder{
		display: block!important;
	}
}
.rangeCheckBox{
	display: flex;
	margin-top: 14px;
	
	>span{
		line-height: 36px;
		margin-right: 10px;
	}
	
	>div{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		overflow-y: auto;
		max-height: 250px;
	}
	
	/deep/ .ant-tag{
		display: flex;
		align-items: center;
		height: 36px;
		min-height: 36px;
		padding: 0 10px;
		background-color: #FFFFFF;
		margin-bottom: 14px;
	}
}

</style>
